import { ValidationErrors } from "../../panels/user/constants";

export function DefaultWorkday() {
}

DefaultWorkday.prototype.init = function(el, data, changesCallback, onScrollCallback) {
    el.innerHTML = "";

    var defaultWorkdayStartEnd = document.createElement("div")
    el.appendChild(defaultWorkdayStartEnd)
    defaultWorkdayStartEnd.classList.add('atNextMount')

    var self = this
    this.errors = {
        [ValidationErrors.WORKDAY_END_BEFORE_WORKDAY_START]: false
    }

    var props = {
        startValue: data.defaultDayStart,
        endValue: data.defaultDayEnd,
        headerClassName: 'defaultDayStartSectionHeader',
        onStartChange: function(value) {
            data.defaultDayStart = value
            changesCallback()
            self._defaultWorkday.setProps({ startValue: data.defaultDayStart })
        },
        onEndChange: function(value) {
            data.defaultDayEnd = value
            changesCallback()
            self._defaultWorkday.setProps({ endValue: data.defaultDayEnd })
        },
        setErrors: function(hasErrors) {
            self.errors[ValidationErrors.WORKDAY_END_BEFORE_WORKDAY_START] = hasErrors
        },
        onScrollCallback: onScrollCallback
    }

    this._defaultWorkday = ClassicBridge.integrateDefaultWorkdayStartEnd(defaultWorkdayStartEnd, props)

    return this;
};

DefaultWorkday.prototype.validate = function() {
    return this.errors
}



// WEBPACK FOOTER //
// ./web/js/userProfile/components/DefaultWorkday.js